export const paymentSelect = [
  { title: 'получена', code: true },
  { title: 'не получена', code: false },
];
